import { fmt } from "@/lib/api";

export function PageHeader({ title, subtitle, right, testid }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8 fade-up" data-testid={testid}>
      <div>
        <h1 className="font-display text-3xl sm:text-4xl font-black tracking-tight text-white">{title}</h1>
        {subtitle && <p className="text-sm text-slate-400 mt-2 max-w-2xl">{subtitle}</p>}
      </div>
      {right}
    </div>
  );
}

const ACCENTS = {
  emerald: "from-emerald-500/20 to-emerald-500/0 text-emerald-400 border-emerald-500/30",
  gold: "from-amber-500/20 to-amber-500/0 text-amber-400 border-amber-500/30",
  cyan: "from-cyan-500/20 to-cyan-500/0 text-cyan-400 border-cyan-500/30",
  violet: "from-violet-500/20 to-violet-500/0 text-violet-400 border-violet-500/30",
  rose: "from-rose-500/20 to-rose-500/0 text-rose-400 border-rose-500/30",
};

export function StatCard({ label, value, icon: Icon, accent = "emerald", money = false, sub, testid, action }) {
  const a = ACCENTS[accent] || ACCENTS.emerald;
  return (
    <div className={`glass rounded-2xl p-5 card-hover relative overflow-hidden`} data-testid={testid}>
      <div className={`absolute -right-6 -top-6 h-24 w-24 rounded-full bg-gradient-to-br ${a} opacity-60 blur-xl`} />
      <div className="flex items-start justify-between relative">
        <span className="text-[0.7rem] uppercase font-mono tracking-[0.18em] text-slate-400">{label}</span>
        {Icon && (
          <span className={`inline-flex h-9 w-9 items-center justify-center rounded-lg border bg-gradient-to-br ${a}`}>
            <Icon className="h-4 w-4" />
          </span>
        )}
      </div>
      <div className="mt-3 font-num text-2xl sm:text-3xl font-bold text-white">
        {money ? fmt(value) : value}
      </div>
      {sub && <div className="text-xs text-slate-500 mt-1">{sub}</div>}
      {action && <div className="mt-3 relative">{action}</div>}
    </div>
  );
}

const PILLS = {
  approved: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  active: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  completed: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  pending: "bg-amber-500/10 text-amber-400 border-amber-500/30",
  inactive: "bg-slate-500/10 text-slate-400 border-slate-500/30",
  rejected: "bg-rose-500/10 text-rose-400 border-rose-500/30",
  failed: "bg-rose-500/10 text-rose-400 border-rose-500/30",
};

export function StatusPill({ status, testid }) {
  const cls = PILLS[status] || PILLS.inactive;
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium border capitalize ${cls}`}>
      {status || "—"}
    </span>
  );
}

export function PackageBadge({ id }) {
  const names = { 1: "Starter", 2: "Pro", 3: "Elite" };
  if (!id) return <span className="text-xs text-slate-500">No package</span>;
  return (
    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-mono font-semibold bg-gradient-to-r from-emerald-500/20 to-cyan-500/20 text-cyan-300 border border-cyan-500/40">
      {names[id]}
    </span>
  );
}

export function Loader({ label = "Loading" }) {
  return (
    <div className="flex items-center justify-center py-24 text-slate-400">
      <div className="h-5 w-5 rounded-full border-2 border-emerald-500 border-t-transparent animate-spin mr-3" />
      {label}...
    </div>
  );
}

export function NameHint({ state, testid }) {
  if (!state) return null;
  if (state.status === "found")
    return (
      <div data-testid={testid} className="text-xs text-emerald-300 mt-1.5 flex items-center gap-1.5">
        <span className="inline-block h-1.5 w-1.5 rounded-full bg-emerald-400" /> {state.name}
      </div>
    );
  if (state.status === "notfound")
    return <div data-testid={testid} className="text-xs text-rose-400 mt-1.5">No user found for this ID</div>;
  return null;
}
